import dataProvider from "src/dataProvider";
import { getGCARegistrationData } from "src/adapter/gcaRegistrationData";

let fetcher = dataProvider("openApiInstance");

const endPoints = {
  gcaDetails: "/user/gca",
  gcaList: "/user/gca/list",
};

export const registerGCA = async (data: any) => {
  try {
    // console.log("[GCA API] Starting GCA registration with data:", JSON.stringify(data, null, 2));
    const response = await fetcher.post("/auth/gca-register", data);
    // console.log("[GCA API] Registration successful:", response.data);
    return response;
  } catch (error: any) {
    console.error("[GCA API] Registration failed:", {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    });
    throw error;
  }
};

export const getGCADetails = async (gcaId: string) => {
  return fetcher.get(`${endPoints.gcaDetails}/${gcaId}`);
};

export const updateGCAProfile = async (gcaId: string, data: any) => {
  return fetcher.put(`${endPoints.gcaDetails}/${gcaId}`, data);
};

export const getGCAList = async (params?: {
  state?: string;
  district?: string;
  expertise?: string[];
}) => {
  return fetcher.get(endPoints.gcaList, params);
};

export const approveGCA = async (gcaId: string) => {
  return fetcher.post(`${endPoints.gcaDetails}/${gcaId}/approve`, {});
};

export const rejectGCA = async (gcaId: string, reason: string) => {
  return fetcher.post(`${endPoints.gcaDetails}/${gcaId}/reject`, { reason });
};

export const updateProfileComprehensive = async (
  userId: string,
  payload: any
) => {
  return fetcher.post(
    `${endPoints.gcaDetails}/update-profile/${userId}`,
    payload
  );
};
export const getGCAUserUpdateHistory = async (userId: string) => {
  return fetcher.get(`${endPoints.gcaDetails}/update-history/${userId}`);
};

export const checkGCAEmailExists = async (
  email: string,
  excludeUserId?: string
) => {
  // 2-segment path on purpose: UserController owns `/user/gca/:id` and is
  // registered first, so any 1-segment literal here gets swallowed as `:id`
  // and crashes Postgres with a non-UUID value. See gca.controller.ts.
  return fetcher.get(`${endPoints.gcaDetails}/email/check`, {
    email,
    ...(excludeUserId ? { excludeUserId } : {}),
  });
};
